import "./styles/style.less";
import { MainRouter } from "./Layout/MainRouter";
import { applyOrgTheme } from "./Layout/applyOrgTheme";
const { apiPrefix, apiUrl, legacyUrl, useBlackTheme } = window as any;

const savedTheme = localStorage.getItem("Theme");
if (useBlackTheme == "true" || (savedTheme && savedTheme !== "default")) {
  applyOrgTheme(parseInt(savedTheme));
}

function App() {
  return <MainRouter />;
}

export default App;
